export default "__VITE_ASSET__BHBjKNcN__"